<template>
  <Transition name="go-top-slide">
    <button
      v-show="visible"
      type="button"
      class="vue-go-top go-top-btn"
      aria-label="Go to top"
      :style="btnStyle"
      @click="scrollTop"
    >
      <span class="vue-go-top__content" aria-hidden="true">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="24"
          height="24"
          fill="currentColor"
        >
          <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" />
        </svg>
      </span>
    </button>
  </Transition>
</template>

<script>
export default {
  name: "GoTop",
  props: {
    size: { type: Number, default: 50 },
    bgColor: { type: String, default: "#d62e2f" },
    bottom: { type: String, default: "55px" },
    right: { type: String, default: "15px" },
  },
  data() {
    return { visible: false };
  },
  computed: {
    btnStyle() {
      return {
        bottom: this.bottom,
        right: this.right,
        width: `${this.size}px`,
        height: `${this.size}px`,
        backgroundColor: this.bgColor,
      };
    },
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.onScroll();
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      this.visible = window.scrollY > 200;
    },
    scrollTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
.go-top-btn {
  position: fixed;
  border: none;
  border-radius: 50%;
  color: #fff;
  z-index: 1000;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
.vue-go-top__content {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
}

.go-top-slide-enter-active,
.go-top-slide-leave-active {
  transition:
    transform 0.35s ease,
    opacity 0.35s ease;
}
.go-top-slide-enter-from {
  opacity: 0;
  transform: translateY(24px);
}
.go-top-slide-enter-to,
.go-top-slide-leave-from {
  opacity: 1;
  transform: translateY(0);
}
.go-top-slide-leave-to {
  opacity: 0;
  transform: translateY(24px);
}
</style>
